import axios from 'axios';

/**
 * Per-agent metrics added in core-api (feat/aht-metric).
 * Date inputs are epoch-ms; endpoints that read query params expect a max
 * range of 31 days (validated server-side). The status/occupancy-global query
 * endpoints use `start` / `end`; the AHT-by-agent POST still uses `startAt` /
 * `endAt`, and per-agent occupancy uses `startDate` / `endDate`.
 */

const toISO = value => new Date(value).toISOString();

const state = {};

const mutations = {};

const actions = {
  // POST /metrics/calls/aht -> [{ id, firstname, lastname, email, averageMinutes }]
  ahtByAgent(context, { start, end } = {}) {
    return axios.post('metrics/calls/aht', {
      startAt: toISO(start),
      endAt: toISO(end),
    }).then(({ data }) => data);
  },

  // GET /metrics/agents/status -> [{ id, firstname, lastname, email, ...statusMinutes }]
  status(context, { start, end } = {}) {
    return axios.get('metrics/agents/status', {
      params: { start: toISO(start), end: toISO(end) },
    }).then(({ data }) => data);
  },

  // GET /metrics/agents/occupancy/global -> [{ date, occupancy: [{ id, ..., percentage }] }]
  // `timezone` is required by the API and must be the account timezone (calls
  // and daily connections are joined by calendar day in that timezone).
  occupancyGlobal(context, { start, end, timezone } = {}) {
    return axios.get('metrics/agents/occupancy/global', {
      params: { start: toISO(start), end: toISO(end), timezone },
    }).then(({ data }) => data);
  },

  // GET /metrics/agents/occupancy/average -> { occupancy } (weighted team rate:
  // total active minutes / total connected minutes, not a mean of daily %).
  occupancyAverage(context, { start, end, timezone } = {}) {
    return axios.get('metrics/agents/occupancy/average', {
      params: { start: toISO(start), end: toISO(end), timezone },
    }).then(({ data }) => data);
  },

  // GET /metrics/agents/occupancy?agent= -> per-agent [{ date, occupancyRate, ... }]
  occupancy(context, {
    agent, start, end, timezone,
  } = {}) {
    return axios.get('metrics/agents/occupancy', {
      params: {
        agent,
        startDate: toISO(start),
        endDate: toISO(end),
        timezone,
      },
    }).then(({ data }) => data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
